<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>序号</th>
          <th>实际充值</th>          
          <th>支付宝</th>
          <th>微信</th>                    
          <th>现金</th>
          <th>赠送</th>
          <th>充值前余额</th>
          <th>时间</th>
          <th>备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" @click="$router.push(`/vip-account-record/${item.idView}`)">
          <td>{{index}}</td>
          <th>{{item.realAccount}}</th>
          <td>{{item.fromAlipay}}</td>
          <td>{{item.fromWechat}}</td>
          <td>{{item.fromCash}}</td>
          <td>{{item.giftAccount}}</td>
          <td>{{item.beforeUserBalance}}</td>
          <td>{{item.createAt | dt}}</td>  
          <td>{{item.mark}}</td>        
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['items']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/AccountRecords.vue